import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(null, async (error) => {
  const original = error.config;
  if (
    error.response?.status === 401 &&
    original &&
    !original._retry &&
    !original.url.includes("/auth/")
  ) {
    original._retry = true;
    try {
      await api.post("/auth/refresh");
      return api(original);
    } catch (e) {
      /* refresh failed */
    }
  }
  return Promise.reject(error);
});

export const imgUrl = (u) =>
  !u ? "" : u.startsWith("http") || u.startsWith("data:") ? u : `${BACKEND_URL}${u}`;

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(", ");
  return "Une erreur est survenue. Réessayez.";
};
